import dispensacao from './dispensacao'
import estornoDispensacao from './estornoDispensacao'
import gerenciamentoBnafar from './gerenciamentoBnafar'
import parametrizacao from './parametrizacao'
import livroPsicotropico from './livroPsicotropico'
import livroTalidomida from './livroTalidomida'
import relatorioDispensacaoPaciente from './relatorioDispensacaoPaciente'
import altoCustoGerenciamentoProcesso from './altoCustoGerenciamentoProcesso'
import relatorioSoaBnafar from './relatorioSoaBnafar'
import relatorioDispensacao from './relatorioDispensacao'
import relatorioPacienteAtendido from './relatorioPacienteAtendido'
import relatorioMovimentacaoPsicotropico from './relatorioMovimentacaoPsicotropico'
import relatorioQuantitativoDispensacao from './relatorioQuantitativoDispensacao'
import relatorioEstornoDispensacao from './relatorioEstornoDispensacao'
import relatorioAltoCustoRetiradaPendente from './relatorioAltoCustoRetiradaPendente'
import relatorioAltoCustoProcesso from './relatorioAltoCustoProcesso'
import relatorioAtendimentoDiario from './relatorioAtendimentoDiario'
import relatorioAltoCustoDispensacao from './relatorioAltoCustoDispensacao'
import relatorioAltoCustoProcessoPaciente from './relatorioAltoCustoProcessoPaciente'
import relatorioAltoCustoEstatisticoCid from './relatorioAltoCustoEstatisticoCid'
import supervisor from './supervisor'
import filaAtendimento from './fila-atendimento'

export default [
    {
        path: 'farmacia',
        component: () => import('@/components/base/RouterViewWrapper'),
        children: [
            ...dispensacao,
            ...estornoDispensacao,
            ...gerenciamentoBnafar,
            ...parametrizacao,
            ...livroPsicotropico,
            ...livroTalidomida,
            ...relatorioDispensacaoPaciente,
            ...altoCustoGerenciamentoProcesso,
            ...relatorioSoaBnafar,
            ...relatorioDispensacao,
            ...relatorioPacienteAtendido,
            ...relatorioMovimentacaoPsicotropico,
            ...relatorioQuantitativoDispensacao,
            ...relatorioEstornoDispensacao,
            ...relatorioAltoCustoRetiradaPendente,
            ...relatorioAltoCustoProcesso,
            ...relatorioAtendimentoDiario,
            ...relatorioAltoCustoDispensacao,
            ...relatorioAltoCustoProcessoPaciente,
            ...relatorioAltoCustoEstatisticoCid,
            ...supervisor,
            ...filaAtendimento,
        ]
    }
]